import { apiClient } from "@/services/api-client";

export const postSubscribeToNewsletter = (payload) => {
  return apiClient({
    url: `/v1/subscriptions`,
    method: "POST",
    params: payload,
  });
};
